import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css'
import { DBDropDownObjective, DBTextFieldObjective, ObjectiveFlag } from '_components';

class PatientCareCenterNoteObjectiveMuskuloRow extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged flagText={`Musculoskeletal ${this.props.id.toString()}`} />
                    <span className={styles.add_button} />
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEPEDSMUSCU'
                        entityKeyColumn='PMNO'
                        entityKeyValue={this.props.id}
                        field='PMMOTION'
                        className={styles.column}
                    />
                     <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEPEDSMUSCU'
                        entityKeyColumn='PMNO'
                        entityKeyValue={this.props.id}
                        field='PMAROM'
                        className={styles.column}
                    />
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEPEDSMUSCU'
                        entityKeyColumn='PMNO'
                        entityKeyValue={this.props.id}
                        field='PMPROM'
                        className={styles.column}
                    /> 
                    <DBDropDownObjective
                          noteId={this.props.noteId}
                          entity='PTOBJECTIVEPEDSMUSCU'
                          entityKeyColumn='PMNO'
                          entityKeyValue={this.props.id}
                          field='PMSTRENGTH'
                          className={styles.arom_hand}
                          masterEntity='PTMASTERSTRENGTH'
                          masterEntityKeyColumn='MSTNO'
                          masterEntitySort='MSTORDER'
                          masterEntityDisplay='MSTNAME'
                     />
                </div>
            </div>
        )
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    return {
        noteId
    };
}

const connectedPatientCareCenterNoteObjectiveMuskuloRow = connect(mapStateToProps)(PatientCareCenterNoteObjectiveMuskuloRow);
export { connectedPatientCareCenterNoteObjectiveMuskuloRow as PatientCareCenterNoteObjectiveMuskuloRow };

